import { render, staticRenderFns } from "./ViqConfidenceBadge.vue?vue&type=template&id=31874de7&scoped=true"
import script from "./ViqConfidenceBadge.vue?vue&type=script&lang=js"
export * from "./ViqConfidenceBadge.vue?vue&type=script&lang=js"
import style0 from "./ViqConfidenceBadge.vue?vue&type=style&index=0&id=31874de7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31874de7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31874de7')) {
      api.createRecord('31874de7', component.options)
    } else {
      api.reload('31874de7', component.options)
    }
    module.hot.accept("./ViqConfidenceBadge.vue?vue&type=template&id=31874de7&scoped=true", function () {
      api.rerender('31874de7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqConfidenceBadge.vue"
export default component.exports